import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const SearchIcon = (p: IconProps) => <Icon {...p}><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></Icon>
